import { Component, Input, OnInit } from "@angular/core";
import { DataService_AppSetup } from "../shared/data.service";

@Component({
	selector: "caass-application-item-table",
	templateUrl: "./application-item-table.component.html",
	styleUrls: ["./application-item-table.component.css"],
})
export class ApplicationItemTableComponent implements OnInit {
	constructor(private tableService: DataService_AppSetup) {}

	//INSERT ON INIT HERE
	ngOnInit(): void {
		// this.user = this.userService.getCurrentUser();
		// this.loadApplicationItem();
	}

	ngOnChanges() {
		this.loadApplicationItem();
	}

	////////////////////////////////////////////
	// Data
	////////////////////////////////////////////

	@Input() ApplicationID: any = "";

	///////////////
	// Built-In
	///////////////

	user: any;
	pagerows: any = 10;
	pagefirst: any = 0;
	loading: any = false;
	errorMessage: any = "";

	///////////////

	///////////////
	// Custom
	///////////////

	//Main
	SelectedApplicationItem: any;
	lstApplicationItem: any = [];

	//Filter lists
	lstSUOnlyDesc: any = [];

	//Cols
	cols: any = [
		//INSERT CUSTOM COLUMNS HERE
		{ field: "ApplicationItemName", header: "Name" },
		{ field: "ParentDesc", header: "Parent" },
		{ field: "SUOnlyDesc", header: "SU Only" },
		{ field: "Order", header: "Order" },
	];

	///////////////

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Load Data
	////////////////////////////////////////////

	loadApplicationItem() {
		if (this.ApplicationID == undefined || this.ApplicationID == "") {
			this.lstApplicationItem = [];

			return;
		}

		this.loading = true;

		var result = this.tableService.ApplicationItemTableSelectList(this.ApplicationID);
		result.subscribe(
			(response) => {
				this.lstApplicationItem = response;

				//Load Data Filter Lists
				this.lstSUOnlyDesc = Array.from(new Set(this.lstApplicationItem.map((item: any) => item.SUOnlyDesc)));

				this.loading = false;
			},
			(error) => {
				this.loading = false;
			}
		);
	}

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Buttons
	////////////////////////////////////////////

	onRefresh() {
		this.loadApplicationItem();
	}

	//Custom Button Methods

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Events
	////////////////////////////////////////////
	onHandleFilter(val) {}
	onHandleSort(val) {}
	onRowSelect(val) {
		this.SelectedApplicationItem = val.data;
	}
	onRowUnselect(val) {
		this.SelectedApplicationItem = null;
	}
	onRowDblClick(ApplicationItem) {
		this.SelectedApplicationItem = ApplicationItem;
	}
	////////////////////////////////////////////
}
